import { useEffect, useState } from 'react';
import { itemToBins } from '../data/bins';
export var useGetBinMappings = function () {
    var _a = useState(undefined), mappings = _a[0], setMappings = _a[1];
    useEffect(function () {
        var itemIdsToBin = itemToBins.reduce(function (acc, item) {
            acc.set(item.id, item);
            return acc;
        }, new Map());
        setMappings(itemIdsToBin);
    }, []);
    return mappings;
};
